import { render, staticRenderFns } from "./ModalInfoProduct.vue?vue&type=template&id=ea468110&scoped=true&"
import script from "./ModalInfoProduct.vue?vue&type=script&lang=js&"
export * from "./ModalInfoProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoProduct.vue?vue&type=style&index=0&id=ea468110&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea468110",
  null
  
)

export default component.exports